import React from 'react';
import { Accordion } from './Accordion';
import { Check } from 'lucide-react';
export function Tomos() {
  const tomos = [{
    number: 'TOMO 1',
    title: 'Tu plata tiene un agujero',
    icon: '🔍',
    quote: 'Sin diagnóstico real, todo lo que ahorrás se escapa por el mismo lugar.',
    items: ['El diagnóstico de los 10 minutos que revela tu agujero financiero real', 'Los 5 gastos hormiga que destruyen el ahorro de cualquier argentino', 'Cómo leer tu resumen bancario sin miedo', 'Identificación de deudas y cuotas que comprometen tu mes', 'Los errores más comunes al manejar el sueldo y cómo evitarlos']
  }, {
    number: 'TOMO 2',
    title: 'El Método de las 3 Cuentas',
    icon: '🏦',
    quote: 'El sistema para que el ahorro ocurra solo, sin depender de tu fuerza de voluntad.',
    items: ['Cómo dividir tu sueldo el día que cobrás para ahorrar automáticamente', 'Dónde abrir cada cuenta en Argentina hoy — gratis, desde el celular', 'Configuración del sistema en menos de 10 minutos', 'Cómo adaptarlo si tenés ingresos irregulares', 'El error que hace que la mayoría abandone en el primer mes']
  }, {
    number: 'TOMO 3',
    title: 'Tu Primer Peso Invertido',
    icon: '📈',
    quote: 'Sin miedo y sin errores: tu primera inversión real esta semana.',
    items: ['Qué es un ETF, un FCI y una cuenta remunerada explicado sin tecnicismos', 'Las 3 opciones más seguras para invertir desde poco en Argentina', 'El paso a paso exacto para ejecutar tu primera inversión', 'Cómo elegir entre CEDEARs, plazo fijo UVA y FCI según tu perfil', 'Los errores que cometen el 90% de los que empiezan']
  }, {
    number: 'TOMO 4',
    title: 'El Interés Compuesto',
    icon: '⚡',
    quote: 'El secreto que nadie te contó: cómo tu plata genera más plata sola.',
    items: ['El cálculo exacto de lo que perdiste por no haber empezado antes', 'Por qué empezar con poco hoy vale 3 veces más que empezar con mucho en 5 años', 'Cómo automatizar tu inversión mensual sin tener que acordarte', 'Proyecciones reales a 1, 5, 10 y 20 años con tus propios números', 'El mito de "necesito mucha plata para invertir" desmontado']
  }, {
    number: 'TOMO 5',
    title: 'Defendé tu Plata de la Inflación',
    icon: '🛡️',
    quote: 'Cuánto te está costando la inflación hoy — el número exacto que duele.',
    items: ['Los 4 escudos disponibles en Argentina y cuál te conviene', 'Cómo abrir un plazo fijo UVA en 5 minutos desde el homebanking', 'CEDEARs explicados sin jerga financiera', 'Cuándo conviene FCI y cuándo plazo fijo tradicional', 'La diferencia real entre ahorrar e invertir contra la inflación']
  }, {
    number: 'TOMO 6',
    title: 'Tu Plan de 30 Días',
    icon: '📅',
    quote: 'Del caos al sistema: el calendario exacto semana a semana.',
    items: ['Día a día de las 4 semanas para implementar todo sin saltear nada', 'Cómo mantener el sistema cuando la vida se complica', 'La revisión mensual de 10 minutos que sostiene todo', 'Checklist de seguimiento para no perder el ritmo', 'Qué hacer si te atrasás o tenés un mes malo']
  }, {
    number: 'TOMO 7',
    title: 'Tu Segundo Ingreso desde Cero',
    icon: '🚀',
    badge: <span className="inline-block bg-gold/20 text-gold text-[10px] font-bold px-2 py-0.5 rounded uppercase tracking-wider mt-1" data-id="element-250">
          EXCLUSIVO PLAN PROFESIONAL
        </span>,
    quote: 'Las 5 maneras más realistas de ganar plata extra sin renunciar a tu trabajo.',
    items: ['Opciones reales para un empleado argentino con poco tiempo', 'El plan de los primeros 7 días para arrancar sin esperar el momento perfecto', 'Cómo integrar el segundo ingreso al sistema de 3 cuentas', 'Errores comunes al empezar un ingreso extra', 'Cómo multiplicar tu interés compuesto con ingresos paralelos']
  }, {
    number: 'TOMO 8',
    title: 'Libertad Financiera Real',
    icon: '⭐',
    badge: <span className="inline-block bg-gold/20 text-gold text-[10px] font-bold px-2 py-0.5 rounded uppercase tracking-wider mt-1" data-id="element-251">
          EXCLUSIVO PLAN PROFESIONAL
        </span>,
    quote: 'El plan a 5 años: de ordenar tus finanzas a construir patrimonio de verdad.',
    items: ['Las 4 etapas del camino con hitos medibles cada 6 meses', 'Tu número de libertad financiera calculado con tu vida real', 'El portafolio de inversiones para un argentino promedio', 'Cómo proyectar tu patrimonio a 5 años con tus números actuales', 'Tu hoja de ruta final hacia la independencia financiera']
  }];
  const includes = ['Explicación sin tecnicismos ni jerga financiera', 'Ejemplos con pesos argentinos reales', 'Herramientas aplicables el mismo día', 'Checklist de implementación y seguimiento', '100% adaptado al contexto argentino 2026'];
  return <section id="tomos" className="bg-navy text-white py-16 px-4" data-id="element-252">
      <div className="max-w-[720px] mx-auto" data-id="element-253">
        <div className="text-center mb-10" data-id="element-254">
          <span className="inline-block bg-white/10 text-white/90 text-xs font-bold px-3 py-1 rounded-full mb-4 border border-white/20 uppercase tracking-wide" data-id="element-255">
            📦 Sistema Completo
          </span>
          <h2 className="text-2xl md:text-3xl font-bold mb-3 leading-tight" data-id="element-256">
            8 tomos. 140 páginas. Todo resuelto.
          </h2>
          <p className="text-[16px] text-white/70" data-id="element-257">
            Del cero absoluto a la libertad financiera real.
          </p>
        </div>

        <div className="flex flex-col gap-3 mb-10" data-id="element-258">
          {tomos.map((tomo, index) => <Accordion key={index} number={tomo.number} title={<span className="font-bold text-[15px]" data-id="element-260">{tomo.title}</span>} icon={<span data-id="element-261">{tomo.icon}</span>} badge={tomo.badge} defaultOpen={index === 0} data-id="element-259">
              <p className="italic text-white/70 text-[14px] mb-4 border-l-2 border-gold pl-3 py-1" data-id="element-262">
                "{tomo.quote}"
              </p>
              <ul className="space-y-3" data-id="element-263">
                {tomo.items.map((item, i) => <li key={i} className="flex items-start gap-2 text-[14px] text-white/90" data-id="element-264">
                    <Check className="text-emerald flex-shrink-0 mt-0.5" size={16} data-id="element-265" />
                    <span className="leading-[1.5]" data-id="element-266">{item}</span>
                  </li>)}
              </ul>
            </Accordion>)}
        </div>

        <div className="bg-white/5 border border-white/10 rounded-2xl p-6" data-id="element-267">
          <h3 className="font-bold text-lg mb-4 text-center" data-id="element-268">
            Cada tomo incluye:
          </h3>
          <ul className="space-y-3" data-id="element-269">
            {includes.map((item, i) => <li key={i} className="flex items-start gap-2 text-[14px] text-white/90" data-id="element-270">
                <Check className="text-emerald flex-shrink-0 mt-0.5" size={18} data-id="element-271" />
                <span data-id="element-272">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}